<div class="graphpad-editor flex flex-col overflow-y-auto p-4">
  <dojo-element-list-section
    [params]="params()"
    [display]="display()"
    [coordSystem]="coordSystem()"
    [behaviorControls]="behaviorControls()"
    (paramsChange)="onParamsChange($event)"
    (displayChange)="onDisplayChange($event)"
    (coordSystemChange)="onCoordSystemChange($event)"
    (behaviorControlsChange)="onBehaviorControlsChange($event)"
  />
</div>
